import { ClassProgress } from './class_progress';
import { RaceProgressRaw } from './interfaces/race_pogress_raw.interface';
import { GpsPoint, Race } from './race';

export type Marshal = {
  rUid: string;
  number: number;
  name: string;
  gpsPoint: GpsPoint;
  phone: string;
  points: number;
  radius: number;
};

export class RaceProgress {
  classes: Array<ClassProgress> = [];
  race!: Race;

  constructor(obj: RaceProgressRaw) {
    this.update(obj);
  }

  update(obj: RaceProgressRaw) {
    this.race = new Race(obj.race);

    if (obj.classes) {
      // Сортируем и создаем классы
      obj.classes.forEach((classObj) => {
        const issetClass = this.classes.find((classItem) => classItem.class.clUid === classObj.class.clUid);
        if (!issetClass) {
          this.classes.push(new ClassProgress(classObj));
        } else {
          issetClass.update(classObj);
        }
      });
    }
  }
}
